/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ChatThreadRoster = zod.object({
  identityKeyed: zod
    .boolean()
    .nullable()
    .describe(
      'Whether this thread is an identity-keyed dm. Null while the projection does not carry the flag yet (unknown, NOT false) — derive display from the roster alone until it arrives.',
    ),
  members: zod
    .array(
      zod.object({
        memberId: zod
          .uuid()
          .describe(
            "The Reach member id: for memberType 'user' a Reach user id — batch these into POST \/participants\/resolve for names — for 'agent' a Reach agent id",
          ),
        memberType: zod.enum(['user', 'agent']),
        role: zod.enum(['owner', 'writer', 'reader']),
      }),
    )
    .describe(
      'The live roster in seating order, the caller included (read your own role off it). Exclude yourself when naming the row.',
    ),
  openInvitationIds: zod
    .array(zod.uuid().describe('UUID v4 identifier'))
    .describe(
      "Core ledger ids of this thread's open invitations, oldest first. Ids only — resolve display text (masked for non-creators) via POST \/participants\/resolve.",
    ),
  threadId: zod.uuid().describe("Reach thread id — join against the Reach SDK's own list"),
});

export type ChatThreadRoster = zod.input<typeof ChatThreadRoster>;
export type ChatThreadRosterOutput = zod.output<typeof ChatThreadRoster>;
